export default __webpack_public_path__ + "static/media/cart.b6059abe.svg";